import { useStatusOverlay } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useQueryParams } from '@fs/zion-router'
import { useCallback } from 'react'
import { useIsOptedIn } from '@fs/zion-soft-launch'
import { useFeatureFlags } from '@fs/zion-flags'

export default function useStatusOverlayTrigger() {
  const showStatusOverlay = useStatusOverlay()
  const [t] = useTranslation()
  const { query } = useQueryParams()
  const {
    rip_sharedImageViewer_fullTextAttachFlowOptIn: fullTextAttachFlowFlagOptIn,
    rip_sharedImageViewer_fullTextAttachFlow_v1: attachFlowV1,
    rip_sharedImageViewer_fullTextAttachFlow_v2: attachFlowV2,
  } = useFeatureFlags([
    'rip_sharedImageViewer_fullTextAttachFlowOptIn',
    'rip_sharedImageViewer_fullTextAttachFlow_v1',
    'rip_sharedImageViewer_fullTextAttachFlow_v2',
  ])
  const { isOptedIn, loading: loadingAttachFlowPrefs } = useIsOptedIn({
    featureFlag: 'rip_sharedImageViewer_fullTextAttachFlow_v1',
  })
  const attachFlowV1IsOn = fullTextAttachFlowFlagOptIn.isOn ? !loadingAttachFlowPrefs && isOptedIn : attachFlowV1.isOn

  const triggerStatusOverlay = useCallback(
    (isSuccess = false, selectPersonToAttachToTreeInfoSheetOverlay = null) => {
      // Only show success overlays in fullText view
      if (query.view !== 'fullText') return

      if (isSuccess) {
        // Only show attach prompt if v1 or v2 flags are enabled
        if (attachFlowV1IsOn || attachFlowV2.isOn) {
          showStatusOverlay({
            message: t('full-text.image.downloaded', 'Image Downloaded. Want to attach this image to the Tree?'),
            type: 'success',
            dismissable: true,
            actionLabel: t('full-text.attach', 'Attach'),
            actionCallback: () => {
              if (selectPersonToAttachToTreeInfoSheetOverlay) {
                selectPersonToAttachToTreeInfoSheetOverlay.open()
              }
            },
          })
        } else {
          // Show success without attach option for users without flags
          showStatusOverlay({
            message: t('full-text.image.downloaded', 'Image Downloaded'),
            type: 'success',
            dismissable: true,
          })
        }
      } else {
        // Still show error overlays regardless of view
        showStatusOverlay({
          message: t('full-text.failed-download', 'Error downloading the file'),
          type: 'error',
        })
      }
    },
    [showStatusOverlay, t, query.view, attachFlowV1IsOn, attachFlowV2.isOn]
  )

  return { triggerStatusOverlay }
}
